<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 所属栏目 -->
        <el-form-item label="SEO标题">
            <el-input size="medium" v-model="params.seoKeyword" placeholder="请输入SEO标题"></el-input>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item label="SEO关键字">
            <el-input size="medium" v-model="params.seoTitle" placeholder="请输入SEO关键字"></el-input>
        </el-form-item>
        <!--  缩略图 -->
        <el-form-item label="SEO描述">
            <el-input size="medium" v-model="params.seoDesc" placeholder="请输入SEO描述"></el-input>
        </el-form-item>
        <!-- 摘要 -->
        <el-form-item label="浏览量">
            <el-input-number v-model="params.views" controls-position="right" @change="handleChange" :min="0"></el-input-number>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="信息页模版">
            <el-input size="medium" v-model="params.modelLink" placeholder="请输入信息页模版"></el-input>
        </el-form-item>
        <el-form-item label="自定义链接">
            <el-input size="medium" v-model="params.customLink" placeholder="请输入自定义链接"></el-input>
        </el-form-item>
        <el-form-item label="排序">
            <el-input-number v-model="params.weight" controls-position="right" @change="handleChange" :min="0"></el-input-number>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
export default {
    props: ['indata'],
    data() {
        return {
            params: {
                seoKeyword: '',
                seoTitle: '',
                seoDesc: '',
                seoDesc: '',
                views: 0, // 内容
                modelLink: '', // 无权限1 有权限2
                customLink: '', // 无权限1 有权限2
                weight: 0,
            },

            rules: {
                // name: [{
                //     required: true,
                //     message: '角色名称不能为空',
                //     trigger: 'blur'
                // }],
            }
        }
    },
    watch: {
        indata: function (e) {
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
            }
        }
    },
    methods: {

        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {

                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.params);
        }

    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .el-input-number {
    width: 240px !important;
}

el--number .subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// subpage3.vue?de1e730c